/**
 * Web EditAccountPageViewModel Adapter
 * Integrates platform-agnostic EditAccountPageViewModel with web-specific services
 */

import { useMemo } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import {
  createEditAccountPageViewModel,
  createWebPlatformServices,
  WebEditAccountPageService,
  type EditAccountPageViewModel
} from '@restaurant/viewmodels'

/**
 * Create web-specific edit account page ViewModel
 * Uses React Router for navigation and web platform services
 */
export const useWebEditAccountPageViewModel = (): EditAccountPageViewModel => {
  const navigate = useNavigate()
  const location = useLocation()

  // Create web-specific platform services (memoized)
  const platformServices = useMemo(() => {
    return createWebPlatformServices(navigate, location)
  }, [navigate, location])

  // Create web-specific service (memoized to prevent infinite re-renders)
  const editAccountPageService = useMemo(() => {
    return new WebEditAccountPageService()
  }, [])

  // Create and return the platform-agnostic EditAccountPageViewModel
  const EditAccountPageViewModelHook = useMemo(() => {
    return createEditAccountPageViewModel(platformServices, { editAccountPageService })
  }, [platformServices, editAccountPageService])

  return EditAccountPageViewModelHook()
}

export default useWebEditAccountPageViewModel
